import React from "react";
import FormNavigation from "../navigation.component";
const InfoPage = (props) => (
  <form
    onSubmit={(e) => {
      e.preventDefault();
      props.nextStep();
    }}
  >
    <div dangerouslySetInnerHTML={{ __html: props.infoPage }} />

    <FormNavigation {...props} />
  </form>
);

export default InfoPage;
